export const formatPrice = (number = Number, currency = "₦") => currency +parseFloat(number).toLocaleString()